// A record of `routeNames` within the buy flow
export const BuyFlowStep = {
	EntryPage: "BuyPersonalisePage",
	AboutYouPage: "BuyAboutYouPage",
	ReviewPayPage: "BuyReviewPayPage",
	SecurityCheckPage: "BuySecurityCheckPage",
	// PaymentPage: "BuyPaymentPage",
	// NearlyDonePage: "BuySummaryPage",
	NextSteps: "NextSteps",
};

export const BuyFlowStepOrder = {
	[BuyFlowStep.EntryPage]: 0,
	[BuyFlowStep.AboutYouPage]: 1,
	[BuyFlowStep.ReviewPayPage]: 2,
	// [BuyFlowStep.NearlyDonePage]: 4,
	[BuyFlowStep.NextSteps]: 3,
};

export const BuyFlowOrderSteps = Object.fromEntries(
	Object.entries(BuyFlowStepOrder).map(([key, value]) => [value, key]),
);
